module.exports = __webpack_public_path__ + "img/groupworks@1x.44c6bde6.webp";